module.exports = __webpack_public_path__ + "media/images/recruitment/pinterest/pinterest-5-09f7840343849e6eaad058673f8c1b96.jpg";